import { useCarSelector } from "@redux/reducers/appConfig";
import { isConfigurationAvailable } from "@shared/helper/isConfigurationAvailable";
import { useIsB2BSelected } from "./useIsB2BSelected";

export const useAvailablePreconfigurations = () => {
  const { preconfigurations } = useCarSelector();
  const isB2BSelected = useIsB2BSelected();

  return preconfigurations.filter(preconfiguration =>
    isConfigurationAvailable(isB2BSelected)(preconfiguration)
  );
};
